// src/modules/app-views/omnichannel/pages/Init/modals/CloseContextModal/index.jsx
// *******************************************************************************
// CLOSE CONTEXT MODAL
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useMemo } from 'react';
import { PoweroffOutlined } from '@ant-design/icons';
import GenericModal from 'components/core/GenericModal';
import appService from 'services/appService';
import useZustand from 'hooks/useZustand';
import omnichannelService from '../../../../service';
import closeContextStep from './Step1';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CloseContextModal = ({ show, setShow, afterClose, conversationId, onSuccess }) => {
  // ---------------------------------------------------------------------------
  // GLOBAL STATE
  // ---------------------------------------------------------------------------
  const storedUser = useZustand('auth', 'user');

  // ---------------------------------------------------------------------------
  // HANDLERS
  // ---------------------------------------------------------------------------
  const handleFinish = async ({ form }) => {
    try {
      const { reason, description } = form.getFieldsValue(true);
      const closedByName = storedUser?.name || storedUser?.fullName || '';
      await omnichannelService.closeContext(conversationId, { reason, description, closedByName });
      appService.message({ flag: 's', text: 'context_closed' });
      onSuccess?.();
    } catch {
      return false;
    }
  };

  // ---------------------------------------------------------------------------
  // MEMOS
  // ---------------------------------------------------------------------------
  const steps = useMemo(() => [closeContextStep()], []);

  // ---------------------------------------------------------------------------
  // UI
  // ---------------------------------------------------------------------------
  return (
    <GenericModal
      show={show}
      setShow={setShow}
      icon={<PoweroffOutlined />}
      title="close_context"
      steps={steps}
      onFinish={handleFinish}
      afterClose={afterClose}
      width={420}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CloseContextModal;
